import {
  CREATE_BANNER_FAILURE,
  CREATE_BANNER_REQUEST,
  GET_ALL_BANNER_REQUEST,
  GET_ALL_BANNER_SUCCESS,
  GET_ALL_BANNER_FAILURE,
  DELETE_BANNER_REQUEST,
  DELETE_BANNER_FAILURE,
  UPDATE_BANNER_REQUEST,
  UPDATE_BANNER_FAILURE,
  GET_ALL_SPECIAL_OFFER_BANNER_REQUEST,
  GET_ALL_SPECIAL_OFFER_BANNER_FAILURE,
  GET_ALL_SPECIAL_OFFER_BANNER_SUCCESS,
  DELETE_BANNER_SUCCESS,
  CREATE_BANNER_SUCCESS,
  UPDATE_BANNER_SUCCESS,
} from "./ActionType";

const initialState = {
  banners: [],
  banner: null,
  specialBanners: [],
  loading: false,
  error: "",
};

export const adminBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_BANNER_REQUEST:
      return { ...state, loading: true };

    case CREATE_BANNER_SUCCESS:
      return { ...state, loading: false, error: "", banner: action.payload };

    case CREATE_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_BANNER_REQUEST:
    case GET_ALL_SPECIAL_OFFER_BANNER_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_BANNER_SUCCESS:
      return { ...state, loading: false, error: "", banners: action.payload };

    case GET_ALL_SPECIAL_OFFER_BANNER_SUCCESS:
      return { ...state, loading: false, error: "", specialBanners: action.payload };

    case GET_ALL_BANNER_FAILURE:
    case GET_ALL_SPECIAL_OFFER_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_BANNER_REQUEST:
      return { ...state, loading: true };

    case DELETE_BANNER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        banners: state.banners?.response?.filter(bnr => bnr.id !== action.payload)  // Remove deleted category
      };

    case DELETE_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_BANNER_REQUEST:
      return { ...state, loading: true };

    case UPDATE_BANNER_SUCCESS:
      return { ...state, loading: false, error: "", banner: action.payload };

    case UPDATE_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
